import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { editProfile } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "Component/Common/Loader";
import useToastr from "helpers/toastr";
import { useTranslation } from "react-i18next";
import ScrollLockModal from "Component/Common/ScrollLock-Model";
import ErrorMessage from "Component/Common/ErrorMessage";
import { error } from "toastr";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ar from "react-phone-input-2/lang/ar.json";
import es from "react-phone-input-2/lang/es.json";
import { use } from "i18next";

export default function EditProfileModal(props) {
  const [errorText, setErrorText] = useState();
  /**
   * Used for initialise the fields on first render
   */
  const [fields, setFields] = useState({
    fname: "",
    lname: "",
    email: "",
    countryCode: "",
    mobileNumber: "",
    codePluseMo: "",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, loading } = useSelector(({ Login }) => Login);
  const [isFormDirty, setIsFormDirty] = useState(false);

  const lang = localStorage.getItem("lang");

  const { t } = useTranslation();

  const toastr = useToastr();

  /**
   * Used for set prefill the fields if they have data
   */
  useEffect(() => {
    if (user !== null) {
      setFields({
        ...fields,
        fname: user?.fname,
        lname: user?.lname,
        email: user?.email,
        codePluseMo: user?.countryCode + user?.mobileNumber,
        countryCode: user?.countryCode,
        mobileNumber: user?.mobileNumber,
      });
    }
    setIsFormDirty(false);
  }, [user, props?.show]);

  const handlePhoneChange = (value, country, e, formattedValue) => {
    let afterStr = formattedValue.split(" ").slice(1).join(" ");
    // let afterLife = formattedValue.split(' ').slice(1).join('')

    let code = country?.dialCode;

    setFields({
      ...fields,
      countryCode: "+" + code,
      mobileNumber: afterStr,
    });
    setIsFormDirty(true);
  };

  /**
   * Used for submit the fields to the api on button click
   */
  const handleSubmit = () => {
    setIsFormDirty(false);

    if (
      fields.fname == "" ||
      fields.lname == "" ||
      fields.email == "" ||
      fields.password == "" ||
      fields.mobileNumber == ""
    ) {
      return toastr.error(t("all_fields_required"));
    }

    const callback = (response) => {
      if (response.status == "success") {
        toastr.success(t("profile_updated_successfully"));
        localStorage.setItem("authUser", JSON.stringify(response));
        props?.onApiCall();
        hidePopup();
        delete fields.codePluseMo;
      } else {
        setErrorText(response.message);
        return;
      }
    };

    let newObj = {
      fname: fields?.fname,
      lname: fields?.lname,
      email: fields?.email,
      countryCode: fields?.countryCode,
      mobileNumber: fields?.mobileNumber,
    };
    dispatch(editProfile(newObj, callback));
  };

  const handleChange = (name) => (e) => {
    let trimmedValue = e.target.value.trim();

    // Check if name is 'fname' or 'lname', and apply regex validation
    if (name === "fname" || name === "lname") {
      // Regular expression to allow only alphabets
      const regex = /^[A-Za-z]+$/;
      // Check if the trimmed value matches the regex
      if (!regex.test(trimmedValue)) {
        // If regex validation fails, return without updating state
        return;
      }
    }

    setFields((prev) => ({ ...prev, [name]: trimmedValue }));
    setIsFormDirty(true);
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 32) {
      e.preventDefault();
    }
  };

  const hidePopup = () => {
    setErrorText("");
    setIsFormDirty(false);
    props.onHide();
  };

  /**
   * Used for render the UI of update profile fields
   */
  return (
    <>
      <ScrollLockModal {...props}>
        {loading && <Loader />}

        <div className="modal_inner_main position-relative">
          <a
            href="javascript:void(0)"
            onClick={() => {
              hidePopup();
              setFields((prev) => ({
                ...prev,
                amount: "",
                address: "",
                note: "",
              }));
            }}
            className="close-btn"
          >
            <img src="/images/close_img.png" alt="" className="img-fluid" />
          </a>

          <div className="modal_buy-cont">
            <h5 className="mb-4">{t("edit_profile")}</h5>

            <h6 className="my-2">
              {t("note")} : {t("kyc_note_profile")}
            </h6>

            <Row>
              <Col className="mt-2" lg={12} sm={12}>
                <FormGroup>
                  <Label for="exampleEmail">
                    {t("first_name")}{" "}
                    <span className="col_red">
                      <sup>*</sup>
                    </span>
                  </Label>
                  <Input
                    type="text"
                    name="fname"
                    id="fname"
                    // placeholder="Jhon"
                    onChange={handleChange("fname")}
                    value={fields?.fname}
                    title={t("fill_this_field")}
                  />
                </FormGroup>
              </Col>
              <Col lg={12} sm={12}>
                <FormGroup>
                  <Label for="exampleEmail">
                    {t("last_name")}{" "}
                    <span className="col_red">
                      <sup>*</sup>
                    </span>
                  </Label>
                  <Input
                    type="text"
                    name="lname"
                    id="lname"
                    // placeholder="Wick"
                    onChange={handleChange("lname")}
                    value={fields?.lname}
                    title={t("fill_this_field")}
                  />
                </FormGroup>
              </Col>

              <Col lg={12} sm={12}>
                <FormGroup>
                  <Label for="exampleEmail">
                    {t("email_id")}{" "}
                    <span className="col_red">
                      <sup>*</sup>
                    </span>
                  </Label>
                  <Input
                    type="email"
                    name="email"
                    id="exampleEmail"
                    // placeholder="Tonynguyen@example.com"
                    onChange={handleChange("email")}
                    value={fields?.email}
                    title={t("fill_this_field")}
                  />
                </FormGroup>
              </Col>

              <Label>
                {t("mobile_number")}{" "}
                <span className="col_red">
                  <sup>*</sup>
                </span>
              </Label>
              <div className="phonenumber_signup position-relative">
                <Col lg={12} sm={12}>
                  <FormGroup>
                    <PhoneInput
                      value={fields?.codePluseMo}
                      onChange={handlePhoneChange}
                      localization={lang == "ar" ? ar : es}
                      title={t("fill_this_field")}
                    />
                  </FormGroup>
                </Col>

                {/* <FormGroup >
                          <Input
                            type="tel"
                            name="number"
                            id="mobile_number"
                            placeholder=""
                            value={fields?.mobileNumber}
                            onChange={handleChange("mobileNumber")}
                            className="ms-3"
                          />
                        </FormGroup> */}
              </div>
            </Row>

            <div className="modal_buy_btn d-flex justify-content-center gap-3">
              <Button
                className="mod_cancelbtn clomod_btn"
                onClick={() => {
                  hidePopup();
                }}
              >
                {t("close")}
              </Button>

              <Button
                disabled={!isFormDirty}
                className="mod_confirmbtn copy_btn"
                onClick={handleSubmit}
                type="submit"
              >
                {t("submit")}
              </Button>
            </div>

            {errorText && <ErrorMessage errorText={errorText} />}
          </div>
        </div>
      </ScrollLockModal>
    </>
  );
}
